import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  output,
  Output,
  SimpleChanges,
} from "@angular/core";
import Swal from "sweetalert2";

@Component({
  selector: "app-adjunto",
  templateUrl: "./adjunto.component.html",
  styleUrls: ["./adjunto.component.scss"],
  providers: [AdjuntoComponent],
})
export class AdjuntoComponent implements OnChanges, OnInit {
  @Input() name: string = ""; //para luego referenciar el output
  @Input() title: string = ""; //Titulo a mostrar sobre el adjunto
  @Input() src: string = ""; //url o ''
  @Output() newBase64: EventEmitter<string | null> = new EventEmitter<
    string | null
  >(); //Base 64 o null
  @Output() deleteAdj: EventEmitter<string | null> = new EventEmitter<
    string | null
  >(); //(VER SI EL NOMBRE ES UNICO PARA CADA IMG)mando el nombre para que se elimine el adjunto en el padre
  @Input() valid: string = "primary"; //Comprueba en padre si es valido y lo setea primary o warn
  @Input() required: boolean = false; //Agrega si es requerido al titulo
  @Input() type: string = "pdf"; //indica el tipo de archivo que se acepta, y lo muestra en el display
  @Input() text: string =
    "Archivo (Max.: 10Mb. - " + this.type.toUpperCase() + ")"; //Si se quiere agregar un texto personalizado. Este pisa al texto por defecto
  @Input() start: "closed" | "open" = "open"; //Si se quiere que la preview comienze abierta o cerrada
  @Input() width: string = "w-full";

  @Input() actions: any = { add: true, delete: true };

  path: string = "";
  extensionReal: string = "";

  verAdjunto: boolean = false;

  /*
    Modo de uso:
      Se importa el modulo AdjuntoModule al modulo donde quieras utilizarlo.
      Se instancia en el html 
      <app-adjunto #nombreAdjunto 
          [name]="'nombreAdjunto'" 
          [title]="'nombreAdjunto'" 
          [src]="srcNombreAdjunto"
          [valid]="'primary'" 
          [required]="true" 
          (newBase64)="newFile($event, nombreAdjunto.name)">
      </app-adjunto>
      Implementar funcion "newFile(base64: any, id: any){}" en el .ts, y manejar el base64 como se requiera.
  */

  /*
    IMPORTANTE:
      En el componente padre, al recibir el @Output en una funcion, NO PISAR el src con el base64 devuelto.
      Esto genera un error de cookies [431 Request Header Fields Too Large].
      Además, no es necesario hacer eso.
  */
  preview: any = false;
  prefix: any = "";
  constructor() {}

  ngOnInit(): void {
    if (!!this.src) {
      this.extensionReal = this.src.split(".").pop();
      this.prefix = this.extensionReal == "pdf" ? "application" : "image";
      this.text =
        this.extensionReal == "pdf"
          ? this.text
          : "Archivo (Max.: 10Mb. - " + this.extensionReal.toUpperCase() + ")";
      this.required ? (this.title = "* " + this.title) : "";
      this.preview = this.src;
    }
    if (this.extensionReal != "") {
      this.type = this.extensionReal;
    }
    if (this.type != "") {
      // fix de tipo cuando el src viene vacío pero type no
      this.text = "Archivo (Max.: 10Mb. - " + this.type.toUpperCase() + ")";
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    //Esto es para cuando es edicion, xq al inicializar el componente, toma src=''
    if (!changes.src?.firstChange) {
      this.extensionReal = this.src.split(".").pop();
      this.type = this.extensionReal;
      this.prefix = this.extensionReal == "pdf" ? "application" : "image";
      this.text =
        this.extensionReal == "pdf"
          ? this.text
          : "Archivo (Max.: 10Mb. - " + this.extensionReal.toUpperCase() + ")";
    }
  }

  onAddAdjunto(event: Event) {
    let fileAdjunto: any;
    const target = event.target as HTMLInputElement;
    fileAdjunto = (target.files as FileList)[0];
    let size = fileAdjunto?.size / 1024; //en Kb
    size = Math.round(size);
    let extension = fileAdjunto?.type.split("/")[1];

    if (size <= 10000) {
      //Max: 2 Mb.
      this._getBase64(fileAdjunto, null).then((data: any) => {
        let b64 = data.split("base64,")[1];
        if (this.prefix == "" && this.extensionReal == "") {
          //Fix xq no se veia la preview mientras cargabas data. Se pone dentro de este if, ya que al editar, si funcionaba.
          this.prefix = "*";
          this.extensionReal = "*";
        }
        if (
          (extension == "jpg" || extension == "jpeg" || extension == "png") &&
          (this.type == "jpg" || this.type == "jpeg" || this.type == "png")
        ) {
          this.preview = data;
          this.newBase64.emit(b64); //Output al componente padre.
          this.valid = "primary";
        } else {
          if (extension == this.type || this.type == "*/*") {
            //filtro formatos permitidos
            this.preview = data;
            this.newBase64.emit(b64); //Output al componente padre.
            this.valid = "primary";
          } else {
            this.valid = "warn";
            Swal.fire({
              icon: "error",
              title: "Extension de archivo no valida",
            });
          }
        }
      });
    } else {
      this.valid = "warn";
      Swal.fire({
        icon: "error",
        title:
          "Tamaño de archivo superado: " +
          fileAdjunto?.name +
          " - " +
          size +
          " Kb",
      });
    }

    if (fileAdjunto.name) {
      this.path = fileAdjunto.name;
    }
  }

  async _getBase64(file: any, url = null): Promise<any> {
    if (url != null) {
      let response = await fetch(url);
      file = await response.blob();
    }
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  classSelect() {
    return this.width;
  }

  //tendría que poner un event emitter que avise al componente padre para eliminar este doc del array?
  remove_attach(type: string) {
    this.preview = false;
    this.verAdjunto = false;
    this.newBase64.emit(null);
  }

  expand(id: any) {}

  verDocumento() {
    this.verAdjunto = !this.verAdjunto;
  }

  loadBase64(data: string) {
    this.preview = data;
    this.prefix = data.includes('pdf') ? 'application' : 'image';
    this.extensionReal = data.includes('pdf') ? 'pdf' : 'jpg';
    this.type = this.extensionReal;
    this.valid = 'primary';
  }
  
}
